import ResponseError from "#/types/responseError"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { carrotClient } from "#/utils/CarrotClient"
import { useQuery, UseQueryResult } from "@tanstack/react-query"

export enum TelemedicineProvider {
  Wheel = "Wheel",
  MedicalPrime = "MedicalPrime",
  TheMenopauseHub = "TheMenopauseHub"
}

interface TelemedicineAvailability {
  isAvailable: boolean
  availableProviders: TelemedicineProvider[]
}

const TELEMEDICINE_AVAILIBILITY_QUERY_KEY = ["telemedicineAvailability"]

export function useTelemedicineAvailability(): UseQueryResult<TelemedicineAvailability, ResponseError> {
  return useQuery({
    queryKey: TELEMEDICINE_AVAILIBILITY_QUERY_KEY,
    queryFn: () => carrotClient.getTelemedicineAvailability(),
    retry: buildCarrotApiRetryPolicy(1),
    refetchOnWindowFocus: false
  })
}
